module.exports = __webpack_public_path__ + "media/Ice_Cream.3e3ce561.mp3";